module.exports = __webpack_public_path__ + "images/mmm-03-desktop.png";